import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class WakeLockService {
    private wakeLock: any = null;
    private isEnabled = false;

    constructor() {
        this.handleVisibilityChange();
    }

    async requestLock() {
        this.isEnabled = true;
        await this.acquire();
    }

    releaseLock() {
        this.isEnabled = false;
        if (this.wakeLock) {
            this.wakeLock.release();
            this.wakeLock = null;
        }
    }

    private async acquire() {
        if ('wakeLock' in navigator && this.isEnabled) {
            try {
                this.wakeLock = await (navigator as any).wakeLock.request('screen');
                this.wakeLock.addEventListener('release', () => {
                    console.log('Wake Lock released');
                });
                console.log('Wake Lock active');
            } catch (err: any) {
                console.error(`Wake Lock error: ${err.name}, ${err.message}`);
            }
        }
    }

    private handleVisibilityChange() {
        document.addEventListener('visibilitychange', async () => {
            if (this.isEnabled && document.visibilityState === 'visible') {
                await this.acquire();
            }
        });
    }
}
